import { IEvent } from "@quest/adapter-interface";
import { Bitmap, detectDeviceEnvironmentConstants, dispatcher, ingenuity } from "@quest/base-core";
import { BaseViewBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther";
import { eventDispatchers } from "../Constants/EventDispatchers";

export class BannerScreenView extends BaseViewBehavior {
    private fullScreenBgAlpha: Bitmap;
    protected resize(evt?: IEvent): void {
        super.resize(evt);
        this.fullScreenBgAlpha = this.getImageById("fullScreenBgAlpha");
        if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.LANDSCAPE) {
            const scale = Math.min(ingenuity.deviceEnv.getLandcapeMaxReelScale());
            this.scale.set(scale, scale);
            this.fullScreenBgAlpha.x = -800;
            this.fullScreenBgAlpha.y = -500;
            this.fullScreenBgAlpha.scale.set(2);
        }
        if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.LANDSCAPE && ingenuity.deviceEnv.getIsIpad()) {
            const scale = Math.min((window.innerHeight / ingenuity.configData.height), (window.innerWidth / ingenuity.configData.width));
            this.scale.set(scale, scale);
            this.fullScreenBgAlpha.x = -640;
            this.fullScreenBgAlpha.y = -525;
        }
        else if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
            this.fullScreenBgAlpha.x = -640;
            this.fullScreenBgAlpha.y = -1123;
             this.fullScreenBgAlpha.scale.y = 3;
        }
        dispatcher.fireEvent(eventDispatchers.CHECK_RESIZE);
    }
    public addToTop(): void {
        ingenuity.currentGame.stage.addChild(this);
        dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BUTTON_PANEL_ON_TOP);
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_FG_BUTTON_PANEL_ON_TOP);
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_TOP_BAR_ON_TOP);
        
    }
}